export default __webpack_public_path__ + "static/media/img-line-egt-mode.7474c148.svg";